/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ConversationCtrl', function(
    $scope,
    $uibModal,
    $location,
    $route,
    ErrorThrower,
    Conversation,
    Message,
    identity
    ) {
        $scope.me                = identity;
        $scope.unread            = 0;
        $scope.last_view         = 1;
        $scope.new_message       =
            {content: ''};
        $scope.acl               =
            {circles: ''};
        $scope.show_possible_acl = false;
        $scope.button_state      = 'fa fa-plus fa-lg';

        $scope.wall_name = $scope.conversation.metas['wall-name'];

        if (($scope.conversation.metas.tags == null)) { $scope.conversation.metas.tags = []; }

        if ($scope.conversation.metas['uv_name'] != null) {
            $scope.wall_name = $scope.conversation.metas['uv_name'] + ' - ' + $scope.wall_name;
            if ($scope.conversation.metas['stage'] != null) {
                $scope.wall_name += ' - ' + $scope.conversation.metas['stage'];
            }
        }

        const errorManager = new ErrorThrower;

        $scope.$on('message:read', function(event, viewed_message) {
            const new_view = {
                user: $scope.me.id,
                created_at: moment().format(),
                updated_at: moment().format()
            };

            return (() => {
                const result = [];
                for (let message of Array.from($scope.conversation.messages)) {
                    if (viewed_message.created_at >= message.created_at) {
                        message.views.push(new_view);
                        if (false === message.viewed) { $scope.unread -= 1; }
                        result.push(message.viewed = true);
                    } else {
                        result.push(undefined);
                    }
                }
                return result;
            })();
        });

        $scope.getAclTooltipContent = function() {
            let content = '';
            const iterable = $scope.conversation.acls.slice(5);
            for (let key = 0; key < iterable.length; key++) {
                const acl = iterable[key];
                if (0 !== key) { content += ', '; }
                content += acl;
            }
            return content;
        };

        const getOtherInfos = function(messages) {
            let message;
            $scope.unread = messages.length - messages.map(message => message.views.filter(function(view) {
                if ($scope.me.id === view.user) { $scope.last_view = messages.indexOf(message); }
                return $scope.me.id === view.user;}).length).reduce((first, second) => first + second);

            // Dans le cas ou le premier message de la conversation est géré différemment
            // on ne veut pas en tenir compte
            if (1 > $scope.last_view) { $scope.last_view = 1; }
            if ($scope.conversation.metas.has_stage_validation === true) {
                for (message of Array.from(messages.reverse())) {
                    if (-1 === message.type.indexOf('quest_')) { continue; }
                    $scope.conversation.style = (() => { switch (message.type) {
                        case 'quest_request': return 'panel-warning';
                        case 'quest_denied':  return 'panel-danger';
                        case 'quest_valid':   return 'panel-success';
                    } })();
                    return;
                }
            }
            $scope.conversation.style = (() => { switch (messages[messages.length - 1].type) {
                case 'message': return 'panel-default';
                case 'notice':  return 'panel-info';
            } })();

            if ('suivi' === $scope.conversation.metas.event_type) {
                return (() => {
                    const result = [];
                    for (message of Array.from(messages)) {
                        result.push($scope.conversation.style = (() => { switch (message.metas.state) {
                            case 'success': return 'panel-success';
                            case 'danger':  return 'panel-danger';
                            case 'warning': return 'panel-warning';
                            default: return 'panel-default';
                        } })());
                    }
                    return result;
                })();
            }
        };

        $scope.getMessages = () => Conversation
        .getMessages({
            conversation_id: $scope.conversation.id})
        .$promise
        .then(function(messages) {
            $scope.conversation.messages = messages;
            for (let message_test of Array.from(messages)) {
                message_test.content = message_test.content
                .replace(/meet\.google\.com|https:\/\/meet\.google\.com/mg, 'https://meet.google.com');
            }
            getOtherInfos(angular.extend([], messages));
            return $scope.conversation.loaded = true;}).catch(error => errorManager.minor(error.statusText));

        $scope.createMessage = function() {
            const modal_instance = $uibModal.open({
                templateUrl: 'directives/conversations/message-preview/modal-template.html',
                controller:  'MessagePreviewCtrl',
                size:        'lg',
                resolve: {
                    message() {
                        return $scope.new_message.content;
                    },
                    acl_empty() {
                        return false;
                    }
                }
            });

            return modal_instance
            .result
            .then(() => Conversation
            .addMessage({ conversation_id: $scope.conversation.id }, $scope.new_message)
            .$promise
            .then(function(new_message) {
                new_message.viewed = true;
                $scope.conversation.messages.push(new_message);
                return $scope.new_message.content = '';}).catch(data => errorManager.minor(data.statusText)));
        };

        $scope.getMessages();

        $scope.addAcl = function() {
            switch (false) {
                case ($scope.conversation.metas['module_id'] == null): return $scope.addAcls();
                default: return $scope.addAclUser();
            }
        };

        $scope.addAclUser = () => Conversation
        .addAclUser({
            conversation_id: $scope.conversation.id,
            circles:         $scope.acl.circles}).$promise
        .then(function(conversation) {
            $scope.conversation.metas['smart-acls'] = conversation.metas['smart-acls'];
            return $scope.conversation.acls                = conversation.metas['smart-acls'];})
        .catch(error => errorManager.minor(error.statusText));

        $scope.addAcls = () => Conversation
        .addAcls({
            conversation_id: $scope.conversation.id,
            circles:         $scope.acl.circles}).$promise
        .then(function(conversation) {
            $scope.conversation.metas['smart-acls'] = conversation.metas['smart-acls'];
            return $scope.conversation.acls                = conversation.metas['smart-acls'];})
        .catch(error => errorManager.minor(error.statusText));

        $scope.showButton = () => ((__guard__($scope.conversation.messages != null ? $scope.conversation.messages[0] : undefined, x => x['user']) != null) &&
            ($scope.conversation.messages[0]['user'] === identity.id)) ||
            Array.from(identity.groups).includes('adm');

        $scope.showPossibleAcls = function() {
            if (false === $scope.show_possible_acl) {
                $scope.show_possible_acl = true;
                $scope.button_state      = 'fa fa-minus fa-lg';
            } else {
                $scope.show_possible_acl = false;
                $scope.button_state      = 'fa fa-plus fa-lg';
            }
            return $scope.metas = $scope.conversation.metas;
        };

        const getUrl = function() {
            if ($location.path() !== `/user/${$route.current.params.login}`) { return false; } else {
                const {
                    metas
                } = $scope.conversation;
                const group = Array.from($scope.me.groups).includes('student') ? 'user' : 'prof';
                return $scope.path_conversation = (() => { switch (metas.wall) {
                    case 'activity': return `#/sessions/${metas.module_id}/${metas['activity-type']}/${metas.activity_id}`;
                    case 'stage':    return `#/sessions/${metas.module_id}/quest/${metas.activity_id}?stage=${metas.stage}`;
                    case 'module':   return `#/${group}/${$scope.me.login}/elearning?id=${metas.module_id}`;
                    case 'promo':    return `#/promo/${metas['wall-name']}`;
                    case 'user':     return `#/user/${metas['wall-name']}`;
                    case 'static':   return `#/wall/${metas['wall-name']}`;
                    default: return false;
                } })();
            }
        };

        if ($scope.conversation.metas['wall-name'] === $route.current.params.login) { return false; } else {}
        return $scope.conversation_origin = getUrl();
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}